import React from 'react';
import { BookOpenIcon, VideoIcon, PackageIcon, UsersIcon, TrendingUpIcon, ShoppingBagIcon } from 'lucide-react';
const features = [{
  icon: BookOpenIcon,
  title: 'Curso completo paso a paso',
  description: 'Aprendé a hacer tabletas aromáticas profesionales desde cero'
}, {
  icon: VideoIcon,
  title: 'Videos tutoriales',
  description: 'Mirá y replicá cada técnica con videos claros y detallados'
}, {
  icon: PackageIcon,
  title: 'Lista de proveedores',
  description: 'Accedé a proveedores confiables y económicos'
}, {
  icon: TrendingUpIcon,
  title: 'Fórmulas exactas',
  description: 'Recetas probadas y optimizadas para mejores resultados'
}, {
  icon: ShoppingBagIcon,
  title: 'Estrategias de venta',
  description: 'Aprendé a vender y escalar tu negocio'
}, {
  icon: UsersIcon,
  title: 'Soporte 24/7',
  description: 'Ayuda cuando la necesites para resolver dudas'
}];
export function FeaturesSection() {
  return <section className="bg-gradient-to-b from-[#F8F8FA] to-white py-16 md:py-24 px-4" data-id="element-70">
      <div className="container mx-auto max-w-4xl" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-73">
            Todo lo que necesitás
          </h2>
          <p className="text-lg text-[#6B6B6B]" data-id="element-74">
            Sistema completo para empezar y crecer tu negocio
          </p>
        </div>

        <div className="space-y-6" data-id="element-75">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <article key={index} className="backdrop-blur-sm bg-white/80 rounded-2xl border border-white/20 shadow-sm p-6 hover:shadow-md transition-all duration-300" data-id="element-76">
                <div className="flex items-start gap-4" data-id="element-77">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#FFD6EC] to-[#FFB3E6] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-78">
                    <Icon className="w-6 h-6 text-[#FF4DB8]" aria-hidden="true" data-id="element-79" />
                  </div>
                  <div data-id="element-80">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-81">
                      {feature.title}
                    </h3>
                    <p className="text-[#6B6B6B]" data-id="element-82">{feature.description}</p>
                  </div>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}